import { render, staticRenderFns } from "./NetworkLabPanel.vue?vue&type=template&id=2c8c9de3"
import script from "./NetworkLabPanel.vue?vue&type=script&lang=js"
export * from "./NetworkLabPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports